export default __webpack_public_path__ + "static/media/Movie.1793d468.png";